interface OvertimeHeaderProps {
  employeeId?: string;
}

export function OvertimeHeader({ employeeId }: OvertimeHeaderProps) {
  return (
    <div className="flex justify-between items-center">
      <h3 className="font-medium">Overtime Records</h3>
      {employeeId && (
        <p className="text-sm text-muted-foreground">
          Employee ID: {employeeId}
        </p>
      )}
    </div>
  );
}
